// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"5f6c77a4","966":"6eb8dfc2"}[chunkId] + ".chunk.css";
};